
import Big from "big.js"
import _ from "lodash";

export default {  

    state: {
        clfTotalReadingTP     : 0,
        clfTotalReadingLP     : 0,
        
        clfSubsysHourlyDataTP : new Map(),
        clfSubsysHourlyDataLP : new Map(),
        
        clfSubsysTypeInfo : [],
    },

    getters: {

        clfTotalReadingTP(state) {
            
            return state.clfTotalReadingTP;
        },
        clfTotalReadingLP(state) {
            return state.clfTotalReadingLP;
        },
        
        clfSubsysHourlyDataTP(state) {
            
            return state.clfSubsysHourlyDataTP;
        },
        clfSubsysHourlyDataLP(state) {
            return state.clfSubsysHourlyDataLP;
        },
        
        clfSubsysTypeInfo( state ){
            return state.clfSubsysTypeInfo;
        },
    },

    mutations: {

        changeClfTotalReadingTP(state, payload) {
            state.clfTotalReadingTP = payload;
        },

        
        changeClfTotalReadingLP(state, payload) {
            state.clfTotalReadingLP = payload;
        },

        changeClfSubsysHourlyDataTP(state, payload) {
            
            state.clfSubsysHourlyDataTP = payload;
        },
        changeClfSubsysHourlyDataLP(state, payload) {
            
            state.clfSubsysHourlyDataLP = payload;
        },
        
        changeClfSubsysTypeInfo( state, payload ){
            state.clfSubsysTypeInfo = payload;
        },
    },

    actions: {

    },

}